import classes from "./Login.module.css";
import { useState, useEffect, useRef, useContext } from "react";
import logo from "../../assets/images/logowithtext.png"
import AppContext from "../../context";
import { AlertEntity } from "../Alert/AlertEntity";
import { UserContextEntity, UserEntity } from "../../entities/UserEntity";
import { AuthService } from "../../services/auth";
import { FaRegEye, FaRegEyeSlash } from "react-icons/fa";

const Login = (props: { showLogin: boolean; setShowLogin: (val: boolean) => void; setUserEntity: (val: UserContextEntity) => void; authService: AuthService; }) => {
  const {
    showLogin,
    setShowLogin,
    setUserEntity,
    authService
  } = props;

  const [username, setUsername] = useState<string>("");
  const [password, setPassword] = useState<string>("");
  const [hidePassword, setHidePassword] = useState<boolean>(true)
  const firstInputRef = useRef<HTMLInputElement | null>(null);

  useEffect(() => {
    if (firstInputRef.current != null) {
      firstInputRef.current.focus();
    }
  }, []);


  const appContext = useContext(AppContext);
  const contextShowAlertFunc = appContext.contextShowAlertFunc;
  const contextShowLoadingFunc = appContext.contextShowLoadingFunc;

  async function clickOK() {
    contextShowLoadingFunc(true);
    try {
      const result = await authService.login(username, password);
      setUserEntity(result);
      setShowLogin(false);
    } catch (error: any) {
      return contextShowAlertFunc(new AlertEntity({ message: error.toString(), level: 3 }));
    } finally {
      contextShowLoadingFunc(false);
    }
  }

  return (
    <>
      {showLogin && (
        <>
          <div className={classes.animation}>
            <div className={classes.formLogin}>
              <h3>LOGIN</h3>
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <img alt="logo-aop" src={logo} style={{ width: "50%" }} />
              </div>

              <p>Enter Your Username & Password</p>
              <div style={{ marginBottom: 'min(12px, 2vh)' }}></div>
              <div className={classes.inputBox}>
                <input
                  ref={firstInputRef}
                  name="LoginUsername"
                  value={username}
                  onChange={(event) => {
                    setUsername(event.target.value);
                  }}
                  required={true}
                  autoComplete="false"
                  onKeyDown={(event) => {
                    if (event.key === 'Enter') {
                      clickOK();
                    }
                  }}
                />
                <span>Username</span>
                <i className={classes.username}></i>
              </div>
              <div style={{ marginBottom: 'min(12px, 2vh)' }}></div>
              <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between", width: "calc(100% - 5px)" }}>
                <div className={classes.inputBox}>
                  <input
                    name={`LoginPassword_${Math.random()}`}
                    value={password}
                    onChange={(event) => {
                      setPassword(event.target.value);
                    }}
                    type={hidePassword == true ? "password" : "text"}
                    required={true}
                    autoComplete="false"
                    onKeyDown={(event) => {
                      if (event.key === 'Enter') {
                        clickOK();
                      }
                    }}
                  />
                  <span>Password</span>
                  <i></i>
                </div>
                <button
                  onClick={() => { setHidePassword(!hidePassword) }}
                  style={{ color: "black", border: "0px solid black", cursor: "pointer", zIndex: "99", backgroundColor: "transparent" }}>
                  {hidePassword == true ? <FaRegEyeSlash /> : <FaRegEye />}
                </button>
              </div>
              <div style={{ marginBottom: 'min(12px, 2vh)' }}></div>
              <button className={classes.buttonLogin} onClick={clickOK}>
                <span>Login</span>
              </button>
              <div></div>
            </div>
          </div>
          <div className={classes.backdroplogin} />
        </>
      )}
    </>
  );
};
export default Login;
